<template>
  <div class="lsit">
    <div class="dataTableOne">
      {{ dataObjs.shishishuju }}
      <div class="icon">
        <!-- <img src="@/assets/img/ck.png" @click="lishData('数据曲线')" alt="窗口化" title="最大化" /> -->
      </div>
    </div>
    <div class="warp">
      <div class="wd" v-for="itemData in shshiData" :key="itemData.channelid">
        <div
          style="height: 79px"
          :class="
            itemData.channelflag == 0
              ? 'greed'
              : itemData.channelflag == 1
              ? 'bult'
              : itemData.channelflag == 3
              ? 'geeds'
              : 'red'
          "
        >
          <div v-if="itemData.channelname != ''" class="titlesImgs">
            {{ itemData.channelname }}
          </div>
          <div v-else class="titlesImgs">
            {{ lang_file == "zh-cn" ? itemData.unittype : itemData.unittype_en }}
          </div>
          <!-- <div>12℃</div> -->
          <div class="font-Sis">{{ itemData.channeldata }}</div>

          <div class="boax_warp">
            <div class="warp_left">{{ itemData.remark }}</div>
            <div class="warp_rigth">{{ itemData.unit }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="top_ewarp">
      <!-- 左边 -->
      <div class="left">
        <div class="lefRight">
          <div class="left_warp">
            <div class="dataTable">
              <span> {{ dataObjs.lishishuju }}</span>
              <div class="newLintgs">
                <div class="filet">
                  <el-button type="success" size="mini" @click="myFileupData">{{
                    dataObjs.daochu
                  }}</el-button>
                </div>
                <div class="timeout">
                  <div class="times">
                    <el-date-picker
                      v-model="value1"
                      type="datetimerange"
                      :range-separator="$t('reach')"
                      format="yyyy/MM/dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      :picker-options="pickerOptions"
                      @change="mytimgEnd"
                      clearable
                    ></el-date-picker>
                  </div>
                  <div class="dayTime">
                    <el-radio-group v-model="tabPosition" @change="dayTime">
                      <el-radio-button label="1hour">{{
                        dataObjs.xiaoshi1
                      }}</el-radio-button>
                      <el-radio-button label="2hour">{{
                        dataObjs.xiaoshi2
                      }}</el-radio-button>
                      <el-radio-button label="1day">{{ dataObjs.tian1 }}</el-radio-button>
                      <el-radio-button label="1week">{{
                        dataObjs.zhou1
                      }}</el-radio-button>
                      <el-radio-button label="1month">{{
                        dataObjs.yue1
                      }}</el-radio-button>
                      <!-- <el-radio-button label="历是数据">清空历数据</el-radio-button> -->
                    </el-radio-group>
                    <el-button
                      size="mini"
                      type="primary"
                      style="height:28px; !important;padding:0 20px !important;margin-top:2px"
                      @click="shuaxinClick"
                      >{{ dataObjs.shuaxin }}</el-button
                    >
                  </div>
                </div>
              </div>
              <div style="padding: 0 10px">
                <el-button
                  size="mini"
                  type="danger"
                  style="heigth:27px; !important"
                  @click="epmoreAll"
                  v-if="roletype == 0"
                  >{{ dataObjs.qingkonglishishuju }}</el-button
                >
              </div>
              <div class="icon">
                <img
                  src="@/assets/img/ck.png"
                  @click="lishData('历史数据')"
                  alt="窗口化"
                  title="最大化"
                />
              </div>
            </div>
            <div style="padding: 10px 0" v-if="cheidFengxiang != ''">
              <el-table
                ref="multipleTable"
                :data="channelidList"
                border
                style="width: 100%"
                :row-class-name="tableRowClassName"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                max-height="370"
              >
                <el-table-column
                  prop="collecttime"
                  :label="dataObjs.riqi"
                  fixed
                  width="130"
                  v-if="chidlenietnsl != ''"
                ></el-table-column>
                <el-table-column
                  v-for="(item, index) in cheidFengxiang"
                  :prop="chidlenietnsl[index]"
                  :label="
                    item.channelname == ''
                      ? lang_file == 'zh-cn'
                        ? item.unittype
                        : item.unittype_en
                      : item.channelname
                  "
                  :key="item.channelid"
                ></el-table-column>
              </el-table>
              <div style="overflow: hidden; height: 40px">
                <dataPheader
                  :page-data="pageData"
                  :total="total"
                  :get-table-list="tableList"
                  @myListPhand="myListPhand"
                ></dataPheader>
              </div>
            </div>
            <!-- <img src="@/assets/img/webp.jpg" v-else class="newimgLongs" alt /> -->
            <p v-else class="textCent">{{ dataObjs.zanwushuju }}}</p>
          </div>

          <div class="right_warp">
            <el-divider>
              <i class="el-icon-monitor"></i>
            </el-divider>
            <div class="dataTable" style="justify-content: space-between">
              {{ dataObjs.shujuquxian }}
              <div class="icon">
                <img
                  src="@/assets/img/ck.png"
                  @click="lishData('数据曲线')"
                  alt="窗口化"
                  title="最大化"
                />
              </div>
            </div>
            <!-- 折线图 -->
            <div class="imgtype" v-if="flyChend == false">
              {{ dataObjs.gaishijianduanzanwushuju }}
            </div>
            <div id="myChart" :style="{ width: '100%', height: '370px' }"></div>

            <div class="zhe_boots">
              <el-radio-group v-model="channelidType" @change="channelidTypeL">
                <el-radio-button
                  :label="'channel' + item.channelid"
                  v-for="item in channelidTtitle"
                  :key="item.channelid"
                  >{{
                    item.channelname == ""
                      ? lang_file == "zh-cn"
                        ? item.unittype
                        : item.unittype_en
                      : item.channelname
                  }}</el-radio-button
                >
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--地图部分和图片部分 -->
    <div class="map_imgWarp">
      <div class="mpar_warp">
        <div class="dataTable">
          {{ dataObjs.ditu }}
          <div class="icon">
            <img
              src="@/assets/img/ck.png"
              @click="lishData('地图')"
              alt="窗口化"
              title="最大化"
            />
          </div>
        </div>
        <!--components里面的的地图 -->
        <mapDlist class="ponstMap" />
      </div>
      <div class="newImage" style="margin: 20px 0" v-if="addressphoto">
        <div class="dataTable">
          {{ dataobjsSend.xianchangtu }}
          <div class="icon">
            <img
              src="@/assets/img/ck.png"
              @click="lishData('现场显示')"
              alt="窗口化"
              title="最大化"
            />
          </div>
        </div>
        <div class="imgLIst">
          <!-- <viewer :images="addressphoto">
          <img :src="addressphoto" alt title="点击可拖拽" />
           </viewer> -->
          <imgPlace :imgUrl="addressphoto" />
          <!-- <img v-else src="https://wlw.shangbensiyuan.com/Uploads/img/noImg.jpg" alt=""> -->
        </div>
      </div>
    </div>

    <div class="padbotn" style="height: 50px" v-if="dataFoont == ''"></div>
    <div class="padbotn" v-else>
      <div class="newImgs" v-for="item in dataFoont" :key="item.id">
        <p style="height: 30px">
          <a :href="item.path">{{ item.title }}</a>
        </p>
        <a :href="item.path">
          <img :src="item.url" alt="" />
        </a>
      </div>
    </div>
    <div style="display: none">{{ valueTime }}</div>
  </div>
</template>

<script>
import { times } from "@/components/common/time";
import dataPheader from "@/components/common/dataPheader";
import mapDlist from "@/components/common/mapDlist";
import { lang_fend, updetaHx } from "@/network/index";
import imgPlace from "./imgPlace";
export default {
  components: {
    dataPheader,
    mapDlist,
    imgPlace,
  },
  props: {
    pageData: {
      type: Object,
      default: {},
    },
    shshiData: {
      type: Array,
      default: [],
    },
    dataMix: {
      type: Array,
      default: [],
    },
    tableList: {
      type: Function,
      default: Function,
    },
    value1: {
      type: Array,
      default: [],
    },
    addressphoto: {
      type: String,
      default: "",
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    flyChend: {
      type: Boolean,
      default: true,
    },
    dataX: {
      type: Array,
      default() {
        return [];
      },
    },
    collecttime: {
      type: Array,
      default() {
        return [];
      },
    },
    channelid: {
      //没有风向
      type: Array,
      default: [],
    },
    cheidFengxiang: {
      type: Array,
      default: [],
    },
    conetnCunt: {
      type: Array,
      default: [],
    },
    teab: {
      type: String,
      default: "",
    },
    delectData: {
      type: String,
      default: "",
    },
    dateset: {
      type: String,
      default: "",
    },
    channelidList: {
      type: Array,
      default: [],
    },
    titleObj: {
      type: Object,
      default: {},
    },
    total: {
      type: Number,
      default: 1,
    },
    excle: {
      type: String,
      default: "",
    },
    lowerlimit: {
      type: Array,
      default: [],
    },
    lowrlimt: {
      type: Array,
      default: [],
    },
    dataobjsSend: {
      type: Object,
      default: {},
    },
    titlenew: {
      type: Object,
      default: {},
    },
  },
  watch: {
    collecttime: {
      handler(value, old) {
        // console.log(this.dataX);
        this.drawLine(value, this.dataX);
      },
      deep: true,
      // immediate: true
    },
    teab: {
      handler(val) {
        // console.log(val);

        this.channelidType = val;
      },
      immediate: true,
    },
    channelidList: {
      handler(val) {
        this.channelidList = val;
      },
      deep: true,
    },
    conetnCunt: {
      handler(val) {
        //  console.log(val)
        this.chidlenietnsl = val;
      },
      deep: true,
    },
    channelid: {
      handler(val) {
        this.channelidTtitle = val;
      },
    },
    dataX: {
      handler(val) {
        // console.log(val,"----4444444444444444444444444444444444444444444444444444444444444-");
        // this.drawLine()
      },
      deep: true,
    },
  },
  data() {
    return {
      pickerOptions: {},
      chidlenietnsl: this.conetnCunt,
      list: [],
      tabPosition: "",
      channelidType: this.teab,
      channelidTtitle: this.channelid,
      // value1:'',
      time: times,
      lang_file: sessionStorage.getItem("lang_file"),
      roletype: sessionStorage.getItem("roletypeValue"),
      arr: this.dataX,
      collecttimeList: this.collecttime,
      objUnit: {},
      tablarr: [],
      dataObjs: {},
      dataFoont: [],
    };
  },
  created() {},
  computed: {
    valueTime() {
      return (this.tabPosition = this.dateset);
    },
  },
  mounted() {
    this.lang_fend();
    this.drawLine();

    this.updetaHx();
    // console.log(this.dataobjsSend);
  },
  methods: {
    async updetaHx() {
      const { code, data } = await updetaHx();
      // console.log(data);
      this.dataFoont = data;
    },
    // 刷新
    shuaxinClick() {
      this.$emit("setClick");
    },
    //删除全部通道好
    epmoreAll() {
      this.$emit("mantClick");
    },
    // 日历的确定按钮
    mytimgEnd(e) {
      console.log(e);
      // console.log(e)
      this.$emit("confingClick", e);
    },
    // 翻译
    async lang_fend() {
      let page = "realtimedata_detail_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      // console.log(data);

      this.dataObjs = data;
      // this.xiaoshi = data.1xiaoshi
    },
    // 下载文件
    myFileupData() {
      this.$emit("myFileupData");
    },
    lishData(e) {
      this.$emit("lishData", e);
    },
    // table表格回到顶部
    myListPhand() {
      this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
    },
    // 斑马线
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    // 确定按钮
    // confingClick() {
    //   this.$emit("confingClick", this.value1);
    // },
    // 时间按钮
    dayTime(e) {
      this.$emit("dayTime", e);
      // this.channelidTypeL()
    },
    channelidTypeL(e) {
      let splNew = e.split("l")[1];

      //  console.log(splNew)
      //  console.log(this.channelidTtitle[nub].upperlimit,"最大");

      // this.lowrlimt.push({
      //    yAxis:this.channelidTtitle[nub].upperlimit//上限
      // })
      // this.lowerlimit.push({
      //   yAxis:this.channelidTtitle[nub].lowerlimit//下限
      // })
      //  console.log(this.lowrlimt);
      //  console.log(this.lowerlimit);

      this.$emit("channelidfunt", e, splNew);
      /**获取标题  */
      this.channelidTtitle.forEach((item) => {
        // console.log(item);

        if (item.unittype != "风向" && "最大降雨量" && "最小降雨量" && "雨雪") {
          if (item.channelid == splNew) {
            this.objUnit = {
              unit: item.unit,
              unittype: this.lang_file == "zh-cn" ? item.unittype : item.unittype_en,
            };
          }
        }
      });
    },
    drawLine(value, data) {
      // console.log();

      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let unt = this.objUnit.unit == undefined ? this.titleObj.unit : this.objUnit.unit;

      // 绘制图表
      let option = {
        title: {
          left: "center",
          text:
            this.objUnit.unittype == undefined
              ? this.titleObj.unittype
              : this.objUnit.unittype,
          // subtext: '纯属虚构'
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          // left: 10,
          // data: ['最高气温',]
        },
        dataZoom: [
          {
            startValue: value == undefined ? this.collecttimeList[0] : value[0],
          },
          {
            type: "inside",
          },
        ],
        // toolbox: {
        //   show: true,
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: "none",
        //     },
        //     dataView: { readOnly: false },
        //     magicType: { type: ["line", "bar"] },
        //     restore: {},
        //     saveAsImage: {},
        //   },
        // },
        //   grid: {
        //   left: "10%",
        //   bottom: "35%",
        // },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: value || this.collecttimeList,
          //    axisLabel: {//x轴旋转文字
          //   rotate: 45, //字体倾斜度数
          //   interval: 0, //interval 是指间隔多少个类别画栅格，为 0 时则每个数据都画，为 1 时间隔 1 个画，以此类推
          //   textStyle: {
          //     //  color:"red", //字体颜色
          //     fontSize: 10, //字体大小
          //   },
          // },
        },
        yAxis: {
          // name:'11',
          type: "value",
          axisLabel: {
            formatter: "{value}" + unt,
          },
        },
        inverse: true,
        visualMap: {
          // inverse:true,
          // dataMix
          yAxis: true,
          show: true,
          top: 10,
          right: 0,
          // orient:"vertical",
          //show:false,
          show: true,
          precision: 1,

          //   // seriesIndex:this.dataX,
          //   dimension: 0,
          pieces: this.dataMix,
          //   // pieces: [
          //   //   {
          //   //     lte: 6,
          //   //     color: "green",
          //   //   },
          //   //   {
          //   //     gt: 6,
          //   //     lte: 8,
          //   //     color: "red",
          //   //   },
          //   //   {
          //   //     gt: 8,
          //   //     lte: 14,
          //   //     color: "green",
          //   //   },
          //   //   {
          //   //     gt: 14,
          //   //     lte: 17,
          //   //     color: "red",
          //   //   },
          //   //   {
          //   //     gt: 17,
          //   //     color: "green",
          //   //   },
          //   // ],
        },

        series: [
          /**有用 */
          // {
          //   color: "red", //折线条的颜色
          //   // name: '最高气温',
          //   smooth: true, //这个是把线变成曲线
          //   type: "line",
          //   markLine: {
          //     silent: true,
          //     data: this.lowrlimt, //上限
          //   },
          // },
          {
            // name: '最低气温',
            // color: "red", //折线条的颜色
            smooth: true, //这个是把线变成曲线
            type: "line",
            data: data || this.dataX,
            markPoint: {
              data: [
                {
                  type: "max",
                  name: "最大值",
                  label: {
                    formatter: function (e) {
                      return "Max:" + e.data.value + unt;
                    },
                  },
                  itemStyle: {
                    color: "red",
                  },
                },
                {
                  type: "min",
                  name: "最小值",
                  label: {
                    formatter: function (e) {
                      return "Min:" + e.data.value + unt;
                    },
                  },
                  itemStyle: {
                    color: "blue",
                  },
                },
              ],
            },
            markLine: {
              silent: true,
              // data: this.lowerlimit, //下限
              data: this.lowrlimt, //上限
              label: {
                formatter: (e) => {
                  return this.titlenew.pingjunzhi + ":" + e.data.value.toFixed(1) + unt;
                },
              },
              // data: [
              //   // { type: "min", name: "最小值" },
              //   [
              //     {
              //       symbol: "none",
              //       x: "90%",
              //       yAxis: "max",
              //     },
              //     {
              //       symbol: "circle",
              //       label: {
              //         // position: "start",
              //         // formatter: "最大值",
              //       },
              //       // type: "max",
              //       // name: "最高点",
              //     },
              //   ],
              // ],
            },
          },
        ],
      };
      myChart.setOption(option);
      // }
      // console.log( this.dataX,"----");
    },
  },
};
</script>

<style scoped>
.dataTable span {
  display: block;
  width: 70px;
  font-size: 16px;
}
#myChart {
  position: relative;
}
.dataTable {
  width: 100%;
  background: #5cb6d9;
  height: 37px;
  line-height: 30px;
  padding: 0 20px;
  color: #ffffff;
  display: flex;
  font-size: 16px;
  align-items: center;
  justify-content: space-between;
  /* margin-top: 40px; */
}
.dataTableOne {
  width: 100%;
  background: #5cb6d9;
  height: 37px;
  line-height: 30px;
  padding: 0 20px;
  color: #ffffff;
  display: flex;
  align-items: center;
  margin-top: 40px;
  font-size: 16px;
}
.mapLint {
  width: 100%;
  height: 500px;
  overflow: hidden;
  position: relative;
}
.lsit {
  width: 100%;
  /* display: flex; */
  /* justify-content: space-between; */
  padding: 0 10%;
}
.top_ewarp {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.icon {
  /* padding: 0 20px; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.icon img {
  width: 20px;
  height: 20px;
  cursor: pointer;
  /* display: flex; */
  /* justify-content: flex-end; */
  /* background: #000; */
}
/* .set {
  width: 20%;
  /* border: 1px solid red; */
/* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
/* height: 500px; */
/* } */
.left {
  width: 100%;
  /* border: 1px solid red; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  /* height: 500px; */
  /* overflow: hidden; */
}
.map_imgWarp {
  display: flex;
  /* justify-content: space-between; */
  flex-direction: column;
}
.newImage {
  /* width: 49%; */
  height: 90vh;
  border: 1px solid #eeeeee;
  overflow: hidden;
}
.errof {
  background: #ffffff;
}
.lefRight {
  display: flex;
  /* justify-content: space-between; */
  flex-direction: column;
  /* height: 500px; */
  overflow: hidden;
}
.right_warp {
  /* width: 49%; */
  /* height: 450px; */
  /* border: 1px solid black; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  /* position: relative; */
  overflow: hidden;
}
.left_warp {
  /* width: 49%; */
  /* height: 450px; */
  /* border: 1px solid black; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  /* overflow: auto; */
}

.times {
  width: 40%;
  display: flex;
  padding: 0 10px 0 0px;
  justify-content: space-between;
}
.timeout {
  width: 100%;
  /* background: #ffffff; */
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04); */
  display: flex;
  align-items: center;
  /* justify-content: center; */
}
.dayTime {
  padding: 0 15px;
  display: flex;
  margin-top: 4px;
}
.mpar_warp {
  /* width: 49%; */
  border: 1px solid #eeeeee;
  height: 500px;
  overflow: hidden;
}
.imgLIst {
  text-align: center;
  height: 100%;
  /* width: 100%;
  display: flex;
  justify-content: center; */
}
.textCent {
  text-align: center;
  padding: 40px;
}
.imgLIst img {
  width: 100%;
  height: 100%;
  /* margin: 0 auto; */
}
.tiemOUts {
  text-align: center;
  padding: 10px 0;
}
.zhe_boots {
  text-align: center;
}
.ponstMap {
  position: relative;
}
.newimgLongs {
  /* width: 100%; */
  width: 50%;
  height: 86%;
  margin: 0 auto;
  display: flex;
  /* overflow: hidden; */
  /* text-align: center; */
}

.filet {
  height: 23px !important;
  line-height: 23px !important;
  margin: 4px 10px;
  cursor: pointer;
}
.warp {
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  padding-bottom: 20px;
}
.wd {
  width: 150px;
  /* border: 1px solid red; */
  text-align: center;
  /* padding: 10px 0; */
  margin: 10px 6px 0px 6px;
  border-radius: 10px;
}
.red {
  /* border: 1px solid red; */
  color: #fff;
  /* background: #ff5353; */
  background-image: url("../../../assets/img/geer.png");
  background-size: cover;
  border-radius: 10px;
  /* padding: 10px 0; */
  /* background-image: linear-gradient(#FF0000, #FF9595); */
}
.greed {
  /* border: 1px solid #0a8e12; */
  color: #ffff;
  /* background: #00c600; */
  background-image: url("../../../assets/img/green.png");
  background-size: cover;
  border-radius: 10px;
  /* padding: 10px 0; */
  /* background-image: linear-gradient(#008000, #00ff80); */
}
.bult {
  /* border: 1px solid #409eff; */
  color: #fff;
  /* background: #0080ff; */
  background-image: url("../../../assets/img/blue.png");
  background-size: cover;
  /* padding: 10px 0; */
  border-radius: 10px;
}
.newWifx {
  margin: 0 5px;
  /* width: 20px;
  height: 20px; */
}
.padbotn {
  height: 200px;
  /* height: 50px; */
  width: 100%;
  background: #ccc;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  /* justify-content: space-around; */
  /* flex-direction: column; */
  /* justify-content: center; */
}
.newImgs {
  width: 130px;
  height: 130px;
  text-align: center;
  margin: 0 10px;
  /* margin: 0 auto; */
}
.newImgs a {
  /* list-style: none; */
  text-decoration: none;
  color: rgb(98, 98, 103);
}
.newImgs img {
  width: 130px;
  height: 130px;
}

.foot_wa {
  display: flex;
  width: 70%;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
}
.boax_warp {
  display: flex;
  justify-content: space-between;
  /* height: 100%; */
  align-items: center;
}
.newLintgs {
  width: 90%;
  display: flex;
  height: 34px;
  align-items: center;
}
.warp_left {
  width: 50%;
}
.warp_rigth {
  width: 50%;
  /* float: right; */
  text-align: right;
  margin-right: 5px;
}
.font-Sis {
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 35%;
}
.titlesImgs {
  display: flex;
  /* align-items: center; */
  justify-content: center;
  padding: 3px 0;
  /* height: 50%; */
}
.geeds {
  color: #fff;
  /* background: #0080ff; */
  /* background-image: url("../../assets/img/violet.png"); */
  background-image: url("../../../assets/img/brown.png");
  background-size: cover;
  border-radius: 10px;
}
.imgtype {
  /* background-image: url('https://img.yzcdn.cn/vant/custom-empty-image.png');
  width: 300px;
  height: 300px; */
  /* background-size: cover; */
  text-align: center;
  /* line-height: 300px; */
  position: absolute;
  font-size: 22px;
  color: #969799;
  margin: 0 auto;
  /* position: fixed; */
  left: 50%;
  top: 50%;
  transform: translate(-50%);
  /* buttom:50%; */
}
</style>
